import { errorMessages } from '@/util/helpers'
const appointmentOfferPauseService = require('../../services/appointmentOfferPause/appointmentOfferPauseService')

const state = {
  activePause: {},
}

const mutations = {
  setActivePause(state, data) {
    state.activePause = data
  }
}

const actions = {
  async fetchActiveAppointmentOfferPause({ commit, dispatch }) {
    commit('setIsLoading', true)

    await
      appointmentOfferPauseService.fetchActivePause()
      .then(({ data }) => {
        commit('setActivePause', data)
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', errorMessages(data.errors))
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  async pauseAppointmentOffer({ commit, dispatch }, body) {
    commit('setIsLoading', true)

    await
      appointmentOfferPauseService.pause(body)
      .then(() => {
        dispatch('fetchActiveAppointmentOfferPause')
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  async resumeAppointmentOffer({ commit, dispatch }) {
    commit('setIsLoading', true)

    await
      appointmentOfferPauseService.resume()
      .then(() => {
        dispatch('fetchActiveAppointmentOfferPause')
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },
}

const getters = {
  activePause: (state) => state.activePause,
}

export default {
  state,
  mutations,
  actions,
  getters,
}
